export default "__VITE_ASSET__DgqET6FM__"